import { defineComponent, ref, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, withDirectives, vShow, createTextVNode, toDisplayString, renderSlot, createVNode, unref, createBlock, withCtx, createCommentVNode } from "vue";
import { IconCaretDown } from "@rei/cedar";
import GenericErrorText from "../GenericErrorText/GenericErrorText.mjs";
const _hoisted_1 = {
  class: "dropdown__label-wrapper"
};
const _hoisted_2 = ["for"];
const _hoisted_3 = {
  class: "pdp-sr-only"
};
const _hoisted_4 = {
  class: "dropdown__link"
};
const _hoisted_5 = {
  class: "dropdown__select-wrapper"
};
const _hoisted_6 = ["id", "aria-describedby", "aria-invalid"];
const _hoisted_7 = ["selected"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericDropdown",
  props: {
    error: {
      type: Boolean
    },
    label: {},
    link: {
      default: () => ({})
    },
    defaultSelected: {
      type: Boolean
    },
    selectId: {}
  },
  emits: ["emitRef", "update"],
  setup(__props, {
    emit: __emit
  }) {
    const dropdown = ref();
    const emit = __emit;
    onMounted(() => {
      emit("emitRef", dropdown.value);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["dropdown", {
          "dropdown--error": _ctx.error
        }])
      }, [createElementVNode("div", _hoisted_1, [createElementVNode("label", {
        for: _ctx.selectId,
        class: "dropdown__label"
      }, [withDirectives(createElementVNode("span", _hoisted_3, " Please select a ", 512), [[vShow, _ctx.defaultSelected]]), createTextVNode(" " + toDisplayString(_ctx.label), 1)], 8, _hoisted_2), createElementVNode("span", _hoisted_4, [renderSlot(_ctx.$slots, "link", {}, void 0, true)])]), createElementVNode("div", _hoisted_5, [createVNode(unref(IconCaretDown), {
        class: "dropdown__select-caret",
        "inherit-color": ""
      }), createElementVNode("select", {
        id: _ctx.selectId,
        ref_key: "dropdown",
        ref: dropdown,
        class: normalizeClass(["dropdown__select", !_ctx.defaultSelected ? "" : "unselected"]),
        "aria-describedby": _ctx.error ? "size-error-text" : void 0,
        "aria-invalid": _ctx.error,
        onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update", $event))
      }, [createElementVNode("option", {
        value: "-1",
        selected: _ctx.defaultSelected
      }, " Select " + toDisplayString(_ctx.label), 9, _hoisted_7), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 42, _hoisted_6)]), _ctx.error ? (openBlock(), createBlock(unref(GenericErrorText), {
        key: 0,
        id: "size-error-text",
        class: "dropdown__error-text"
      }, {
        default: withCtx(() => [createTextVNode(" Please select a " + toDisplayString(_ctx.label), 1)]),
        _: 1
      })) : createCommentVNode("", true)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericDropdown2.mjs.map
